import { useEffect, useReducer, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import Select from "react-select";
import { optionSelector } from "../../../config/apiSPA.js";
const presetData = {
  partId: null,
  evalId: null,
};
const reducer = (state, action) => {
  switch (action.type) {
    case "partId":
      return { ...state, partId: action.value };
    case "evalId":
      return { ...state, evalId: action.value };
    case "RESET":
      return presetData;
    default:
      return state;
  }
};
export default function ModalTel3AddPart({ show, onHide, submitClick = () => {}, options = {} }) {
  const title = options.title ?? "No Title";
  const text = options.text ?? "please text here";
  const [selected, dispatch] = useReducer(reducer, presetData);
  const [option, setOption] = useState([]);
  const [loading, setLoading] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(true);

  useEffect(() => {
    if (!show) return;

    const fetchOption = async () => {
      try {
        const res = await optionSelector(`/manpower`);
        setOption(res);
        setLoading(false);
      } catch {
        setOption([]);
      }
    };
    fetchOption();
  }, [show]);

  useEffect(() => {
    dispatch({ type: "RESET" });
    if (!show) setLoading(true);
  }, [show]);
  useEffect(() => {
    setBtnDisabled(!selected.partId || !selected.evalId);
  }, [selected]);
  return (
    <Modal show={show} onHide={onHide}>
      <ModalHeader closeButton>
        <h5 className="modal-title">{title}</h5>
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <p>Loading.....</p>
        ) : (
          <>
            <div className="form-group mb-3">
              <label className="form-label text-theme" htmlFor="activityId">
                Participant<span className="text-danger">*</span>
              </label>
              <div className="mb-3">
                <Select onChange={(e) => dispatch({ type: "partId", value: e.value })} options={option} isSearchable classNamePrefix="react-select" />
              </div>
            </div>
            <div className="form-group mb-3">
              <label className="form-label text-theme" htmlFor="activityId">
                Evaluator<span className="text-danger">*</span>
              </label>
              <div className="mb-3">
                <Select onChange={(e) => dispatch({ type: "evalId", value: e.value })} options={option} isSearchable classNamePrefix="react-select" />
              </div>
            </div>
            <div className="alert bg-inverse bg-opacity-15">{text}</div>
          </>
        )}
      </ModalBody>

      <ModalFooter>
        <button type="button" disabled={btnDisabled} onClick={() => submitClick(selected)} className="btn btn-outline-theme">
          Save changes
        </button>
      </ModalFooter>
    </Modal>
  );
}
